import { CacheManager } from '../utils/cacheManager';
import { normalizeArrayData } from '../utils/dataFormatHandler';

class CollectionsService {
  constructor() {
    // Use proxy in development, direct URL in production
    this.baseUrl = process.env.NODE_ENV === 'development' ? '' : 'https://rainbow-sails.shop';
    this.cacheManager = new CacheManager(5 * 60 * 1000); // 5 minutes
    
    console.log('🚀 [SERVICE] CollectionsService initialized');
    console.log('🌐 [SERVICE] Base URL:', this.baseUrl || 'Using proxy');
  }

  async getCollections() {
    console.log('🚀 [FUNCTION] getCollections called');
    console.log('⏰ [TIME]', new Date().toISOString());
    console.log('🚀 [START] Fetching collections from server...');
    
    try {
      const url = `${this.baseUrl}/collections/index.json`;
      console.log('📡 [API] Fetching collections from:', url);
      
      const response = await fetch(url);
      console.log('📡 [API] Response received:', {
        status: response.status,
        statusText: response.statusText,
        ok: response.ok,
        url: response.url
      });
      
      if (!response.ok) {
        // If file doesn't exist, return empty array (collections are optional)
        if (response.status === 404) {
          console.log('⚠️ [API] Collections file not found, returning empty array');
          return [];
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('📊 [API] Raw data received:', data);
      
      // Handle both array format and object format
      const collections = normalizeArrayData(data, 'collections', 'collections');
      
      // Filter to only published collections for frontend
      const publishedCollections = collections.filter(c => c.published !== false && c.status !== 'draft');
      
      console.log('📊 [API] Collections data processed:', {
        totalCount: collections.length,
        publishedCount: publishedCollections.length,
        collections: publishedCollections.map(c => ({ id: c.id, name: c.name }))
      });
      
      this.cacheManager.set(publishedCollections);
      console.log('💾 [CACHE] Collections cached successfully');
      console.log('✅ [SUCCESS] Collections loaded from server index:', publishedCollections.length);
      return publishedCollections;
    } catch (error) {
      console.error('❌ [ERROR] Error fetching collections:', error);
      // Don't fail the whole app if collections fail to load
      return [];
    }
  }

  async getCollection(collectionSlug) {
    console.log('🚀 [FUNCTION] getCollection called with slug:', collectionSlug);
    console.log('⏰ [TIME]', new Date().toISOString());
    
    try {
      // First get all collections to find the one matching the slug
      const collections = await this.getCollections();
      
      // Find collection by slug (name converted to slug format)
      const collection = collections.find(c => 
        c.name.toLowerCase().replace(/\s+/g, '-') === collectionSlug.toLowerCase()
      );
      
      if (!collection) {
        console.log('⚠️ [API] Collection not found:', collectionSlug);
        return null;
      }
      
      // Get full collection data - for now return what we have
      // In future, could fetch from individual collection file
      console.log('✅ [SUCCESS] Collection loaded successfully:', collectionSlug);
      return collection;
    } catch (error) {
      console.error('❌ [ERROR] Error fetching collection:', error);
      return null;
    }
  }

  clearCache() {
    console.log('🚀 [FUNCTION] clearCache called');
    console.log('🗑️ [CACHE] Clearing collections cache...');
    
    this.cacheManager.clear();
    
    console.log('✅ [SUCCESS] Collections cache cleared successfully');
  }
}

const collectionsServiceInstance = new CollectionsService();
export default collectionsServiceInstance;

